import React from 'react';
import { 
  CalendarButtonControl, 
  ExportButtonControl, 
  AreaSelectorControl 
} from 'components/ReportHeader/controls';

/**
 * R0006 Header Controls Configuration with Access Control
 * Extends the base configuration with access control logic
 */
export const R0006_ACCESS_CONTROLLED_HEADER_CONFIG = {
  leftControls: [],
  
  centerControls: [
    {
      id: 'area-selector',
      component: AreaSelectorControl,
      props: {
        variant: 'yellow',
        label: 'Area'
      },
      // Show area selector if user has data ready
      // For area-restricted users, they can select from their accessible areas
      // For full-access users, they can select from all areas
      showWhen: (state) => state.dataReady,
      order: 1
    }
  ],
  
  rightControls: [
    {
      id: 'calendar-button',
      component: CalendarButtonControl,
      props: {
        variant: 'titleColor',
        tooltip: 'Select Date Range'
      },
      showWhen: () => true, // Always show
      order: 1
    }
  ]
};